import styles from './ManageUsers.module.css';
import Header from "../../components/common/header/Header";
import { getAllUsers } from "../../services/User.service"
import { useEffect } from "react";
import { usersSelector } from "../../hooks/store/getters";
import { useAppStore } from "../../hooks/store/useAppStore";
import { setUsersSelector } from "../../hooks/store/setters";
import Container from "react-bootstrap/Container";
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdAdd } from "react-icons/md";
import Input from '../../components/common/input/Input';
import Table from 'react-bootstrap/Table'
import Badge from 'react-bootstrap/Badge'
import ManageUserProfile from './../../components/manage-user-profile/ManageUserProfile';
import { useState } from 'react';
import { USER_ROLES } from './../../constants/UserRoles.const';
import { updateUserProfile } from './../../services/User.service';

const userRoles = Object.keys(USER_ROLES).map(role => ({
    label: role,
    value: role,
}))



const ManageUser = () => {
    const users = useAppStore(usersSelector);
    const setUsers = useAppStore(setUsersSelector);
    
    const [filteredUsers, setFilteredUsers] = useState([])
    const [showManageProfile, setShowManageProfile] = useState(false)
    const [profleViewMode, setProfleViewMode] = useState(false)
    const [manageUser, setManageUser] = useState(null)
    const [filters, setFilters] = useState({
        searchStr: "",
        role: ''
    })

    useEffect(()=>{
        const getUsers = async () => {
            const users = await getAllUsers();
            setUsers(users);
        }
        getUsers();
    },[setUsers])
    
    useEffect(() => {
        console.log('filters changed ', filters);
        
        const searchStr = filters.searchStr.toLowerCase()
        const role = filters.role
        
        const filteredUsers = users.filter(user => {
            if (role) {
                if (!user.userRole && role === USER_ROLES.USER) {
                    return true
                }
                
                if (
                    user.userRole === role && (
                        user.userName.toLowerCase().includes(searchStr) ||
                        user.email.toLowerCase().includes(searchStr)
                    )
                ) {
                    return true
                }
            } else {
                if (
                    user.userName.toLowerCase().includes(searchStr) ||
                    user.email.toLowerCase().includes(searchStr)
                ) {
                    return true
                }
            }
            
            return false
        })
        
        setFilteredUsers(filteredUsers)
        
    }, [users, filters, setFilteredUsers])
    
    const updateFilterData = ({ target: { name, value } }) => {
        console.log('update filer', {name, value});
        
        setFilters({
            ...filters,
            [name]: value
        })
    }
    
    const closeManageProfile = (updatedUser) => {
        console.log('closeManageProfile');
        if (updatedUser) {
            const { newlyAdded=false, ...data } = updatedUser;
            
            if (newlyAdded) {
                setUsers([
                    ...users,
                    { ...data }
                ])
            } else {
                setUsers([
                    ...users.map(u => {
                        if (u.uid === updatedUser.uid) {
                            return {
                                ...u,
                                ...updatedUser
                            }
                        }
                        return u
                    })
                ])
            }
            
        }
        
        setShowManageProfile(false)
        setManageUser(null)
        setProfleViewMode(false)
    }
    
    const openManageProfile = () => {
        setShowManageProfile(true)
    }
    
    
    const manageProfile = user => {
        setManageUser(user)
        openManageProfile()
    }
    
    const viewProfile = user => {
        setProfleViewMode(true)
        setManageUser(user)
        openManageProfile()
    }
    
    const updateProfileStatus = async (user, isDisabled) => {
        const result = await updateUserProfile({
            ...user,
            isDisabled
        })
        console.log('update Profile status', {user, result, isDisabled})
        closeManageProfile(result)
    }
    
    const enableProfile = user => {
        updateProfileStatus(user, false)
    }
    
    
    const disableProfile = user => {
        updateProfileStatus(user, true)
    }
    

    return (  
        <div className={styles.userListWraper}>
            <Header />
            <Container fluid="md">
                
                {/* Header */}
                <div className={styles.userListHeader}>
                    <Row className="align-items-center">
                        <Col md={9} sm={12}>
                            <div>
                                <h1>Manage Users</h1>
                                <p>
                                    View and Edit Users of the platform
                                </p>
                            </div>
                        </Col>
                        <Col md={3} sm={12}>
                            <Button variant="warning" size="lg" className={styles.createUserBtn}
                                onClick={openManageProfile}
                            >
                                <span className={styles.btnText}>Create User</span>
                                <MdAdd className={styles.btnIcon} />
                            </Button>
                        </Col>
                    </Row>
                </div>
                {/* Header */}
                
                {/* Filters */}
                <div className={styles.TourListFilter}>
                    <Row className="w-100">
                        <Col md={5} sm={12}>
                        <Input
                                variant="dark"
                                placeholder="Search users"
                                name="searchStr"
                                value={filters.searchStr}
                                onChange={(e) => updateFilterData(e)}
                            />
                        </Col>

                        <Col md={2} sm={6} xs={6}>
                            <Input type="select"
                                variant="dark"
                                placeholder="Role"
                                name="role"
                                value={filters.role}
                                options={userRoles}
                                onChange={(e) => updateFilterData(e)}
                            />
                        </Col>
                    </Row>
                </div>
                {/* Filters */}
                
                <Table striped borderless hover className={styles.userTable}>
                    <thead>
                        <tr>  
                            <th>Name</th>  
                            <th>Email</th>  
                            <th>Role</th>  
                            <th>Last Login</th>  
                            <th>Action</th>  
                        </tr>
                    </thead>
                    
                    <tbody>
                        { filteredUsers.map((user, index) => (  
                            <tr data-index={index} key={index}>  
                                <td>{user.userName}</td>  
                                <td>{user.email}</td>
                                <td>{user.userRole || USER_ROLES.USER}</td>
                                <td>{ user.lastSignedIn ? new Date(user.lastSignedIn).toLocaleString() : '-' }</td>
                                <td>
                                    <Badge 
                                        pill 
                                        variant="info"
                                        className={styles.actionPill} 
                                        onClick={() => viewProfile(user)}
                                    >View</Badge>
                                    <Badge 
                                        pill 
                                        variant="warning"
                                        className={styles.actionPill} 
                                        onClick={() => manageProfile(user)}
                                    >Edit</Badge>
                                    { 
                                        !user.isDisabled ? <Badge 
                                            pill 
                                            variant="danger"
                                            className={styles.actionPill} 
                                            onClick={() => disableProfile(user)}
                                        >Disable</Badge> : <Badge 
                                            pill 
                                            variant="success"
                                            className={styles.actionPill} 
                                            onClick={() => enableProfile(user)}
                                        >Enable</Badge> 
                                    }
                                </td>
                            </tr>  
                        ))}
                    </tbody>
                </Table>
            </Container>
        
            {
                showManageProfile && <ManageUserProfile 
                    show={showManageProfile}
                    onClose={closeManageProfile}
                    user={manageUser}
                    viewMode={profleViewMode}
                />
            }
            
        </div>
    );  
}
export default ManageUser;